# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedProject extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedProjectModule'
#
#   @selector: ".featured_project_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedProject.register()
